import { PinOutlineIcon } from './PinOutlineIcon';

/**
 * author: Google
 * id BF736212-EE8D-49D0-8C8B-63A463488E88
 * name pin-outline
 * version: 2.3.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/pin-outline.svg
 * tags
 */
export const KeepOutlineIcon = PinOutlineIcon;
export default KeepOutlineIcon